import { useIsMobile } from '@patrianna/shared-hooks'
import cx from 'classnames'
import { createContext, useState } from 'react'
import type { ReactNode } from 'react'

import useIsAuthPage from 'hooks/useIsAuthPage'
import DialogCaption from 'src/dialogs/components/DialogCaption'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ManualLoginContext = createContext({ loginPassed: false, setLoginPassed: (loginPassed: boolean) => {} })
ManualLoginContext.displayName = 'ManualLoginContext'

const ManualLoginProvider = ({ children }: { children: ReactNode }) => {
  const [loginPassed, setLoginPassed] = useState(false)

  return <ManualLoginContext.Provider value={{ loginPassed, setLoginPassed }}>{children}</ManualLoginContext.Provider>
}

type Props = {
  children: ReactNode
  title?: string
  dataTest: string
}

export default function AuthDialogLayout(props: Props) {
  const { isDarkMode } = useThemeContext()
  const isAuthPage = useIsAuthPage()
  const isMobile = useIsMobile()

  const layoutContentVisible = isAuthPage !== undefined && !(isAuthPage && isMobile)
  const logoImgUrl = `${process.env.IMG_ORIGIN}/logos/logo_full_${isDarkMode ? 'white_' : ''}${
    process.env.BRAND_NAME
  }_v3.svg`

  return (
    <ManualLoginProvider>
      <div className={cx(classes.root, 'mt-paper')}>
        {layoutContentVisible && (
          <div className={classes.header}>
            {props.title ? (
              <DialogCaption classNames={{ root: classes.caption }}>{props.title}</DialogCaption>
            ) : (
              <img className={classes.icon} src={logoImgUrl} alt='logo' />
            )}
          </div>
        )}

        {props.children}
      </div>
    </ManualLoginProvider>
  )
}
